import React from 'react';
import './DealTable.css';

interface Deal {
  id: string;
  name: string;
  type: string;
  discountLabel: string;
  status: 'active' | 'scheduled' | 'paused' | 'expired';
  activeDates: string;
  usage: number;
  revenueImpact: string;
  isActive: boolean;
}

interface DealTableProps {
  deals: Deal[];
  selectedDeals: string[];
  onSelectDeal: (dealId: string) => void;
  onSelectAll: () => void;
  onToggleActive: (dealId: string) => void;
}

const DealTable: React.FC<DealTableProps> = ({
  deals,
  selectedDeals,
  onSelectDeal,
  onSelectAll,
  onToggleActive,
}) => {
  const allSelected = selectedDeals.length === deals.length && deals.length > 0;

  const getStatusClass = (status: Deal['status']) => {
    return status.toLowerCase();
  };

  return (
    <div className="deal-table-container">
      <table className="deal-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={onSelectAll}
                className="table-checkbox"
              />
            </th>
            <th>Deal ID</th>
            <th>Name</th>
            <th>Type</th>
            <th>Discount</th>
            <th>Status</th>
            <th>Active Dates</th>
            <th>Usage</th>
            <th>Revenue Impact</th>
            <th>Active</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {deals.map((deal) => (
            <tr key={deal.id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedDeals.includes(deal.id)}
                  onChange={() => onSelectDeal(deal.id)}
                  className="table-checkbox"
                />
              </td>
              <td className="deal-id">{deal.id}</td>
              <td className="deal-name">{deal.name}</td>
              <td className="deal-type">{deal.type}</td>
              <td>
                <span className="deal-discount">{deal.discountLabel}</span>
              </td>
              <td>
                <span className={`deal-status status-${getStatusClass(deal.status)}`}>
                  {deal.status}
                </span>
              </td>
              <td className="deal-dates">{deal.activeDates}</td>
              <td className="deal-usage">{deal.usage}</td>
              <td className="deal-revenue">{deal.revenueImpact}</td>
              <td>
                <label className="deal-toggle">
                  <input
                    type="checkbox"
                    checked={deal.isActive}
                    onChange={() => onToggleActive(deal.id)}
                  />
                  <span className="deal-toggle-slider" />
                </label>
              </td>
              <td>
                <button className="deal-actions-btn">⋯</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DealTable;

